import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PhoneNumberValidatorService {

  private readonly validAreaCodes = [204, 226, 236, 249, 250, 257, 263, 289, 306, 343, 354, 365, 367, 368, 382, 403, 416, 418, 428, 431, 437, 438, 450, 468, 474, 506, 514, 519, 548, 579, 581, 584, 587, 604, 613, 639, 647, 672, 683, 705, 709, 742, 753, 778, 780, 782, 807, 819, 825, 867, 873, 879, 902, 905, 942];

  isValid(strPhoneNumber: string): boolean {
    const parsedNumber: string = String(strPhoneNumber).replace(/\D+/g, '');

    if (parsedNumber.length === 10) {
      return this.validAreaCodes.some(
        (anAreaCode: number) => anAreaCode.toString() === parsedNumber.substring(0, 3));
    }

    return false;
  }
}
